/**
 * @implements ImportSourceDataType
 * @type BadgrBadgeType
 */
export const BadgrBadgeType = {
    name: 'badge',
    sourceName: 'Badges',
};
